<template>
    <div>
        <el-dialog :visible.sync="sta.show">
            <span slot="title">提醒时间设置（每日安全巡检）</span>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label><b>巡检前提醒时间</b></label><br />
                        <el-time-select v-model="PREVIEW" :picker-options="{
                            start: '05:00',
                            step: '00:15',
                            end: '23:00'
                        }" placeholder="选择时间" :disabled="state">
                        </el-time-select>
                    </div>
                    <div class="form-group">
                        <label><b>过期未巡检提醒时间</b></label><br />
                        <el-time-select v-model="AFTER" :picker-options="{
                            start: '05:00',
                            step: '00:15',
                            end: '23:00'
                        }" placeholder="选择时间" :disabled="state">
                        </el-time-select>
                    </div>
                </div>
            </div>
            <div slot="footer" v-loading="sta.loading">
                <el-button v-if="state" icon="el-icon-bell" type="primary" @click="open">开启提醒</el-button>
                <el-button v-else icon="el-icon-close-notification" type="danger" @click="close">关闭提醒</el-button>
                <el-button icon="el-icon-close" @click="sta.show = false">取消</el-button>
                <el-button icon="el-icon-check" type="success" @click="submit">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            sta: {
                show: false,
                loading: false
            },
            model: {},
            PREVIEW: '',
            AFTER: '',
            check: true,
            state: false
        }
    },
    methods: {
        init() {
            this.sta = { show: true, loading: false }
            let self = this;
            self.PREVIEW = ''
            self.AFTER = ''

            this.sta.loading = true;
            this.whale.remote.getResult({
                url: "/api/School/FX/DictApi/getByName",
                data: { NAME: "DAY_NOTICE", TYPE: "SAFE" },
                finally() { self.sta.loading = false; },
                completed: function (its) {
                    // console.log('getByName', its.DATA)
                    if (its.DATA) {
                        its.DATA.DESCRIPTION = JSON.parse(its.DATA.DESCRIPTION)
                        self.model = its.DATA;
                        self.PREVIEW = its.DATA.DESCRIPTION.PREVIEW
                        self.AFTER = its.DATA.DESCRIPTION.AFTER
                        self.check = true
                    } else {
                        self.model = {
                            NAME: "DAY_NOTICE",
                            TYPE: "SAFE",
                            VALUE: "TIME",
                            DESCRIPTION: {
                                PREVIEW: self.PREVIEW,
                                AFTER: self.AFTER,
                            }
                        }
                        self.check = false
                    }
                    if (self.model.DESCRIPTION.PREVIEW || self.model.DESCRIPTION.AFTER)
                        self.state = false
                    else
                        self.state = true
                }
            })
        },
        submit() {
            let self = this;
            if (!self.check) {
                self.model = {
                    NAME: "DAY_NOTICE",
                    TYPE: "SAFE",
                    VALUE: "TIME",
                    DESCRIPTION: {
                        PREVIEW: self.PREVIEW,
                        AFTER: self.AFTER,
                        PREVIEW_DONE: self.$moment().format("YYYY-MM-DD HH:mm:ss"),
                        AFTER_DONE: self.$moment().format("YYYY-MM-DD HH:mm:ss")
                    }
                }
            } else {
                self.model.DESCRIPTION.PREVIEW = self.PREVIEW
                self.model.DESCRIPTION.AFTER = self.AFTER
            }
            self.model.DESCRIPTION = JSON.stringify(self.model.DESCRIPTION)
            self.sta.loading = true;
            this.whale.remote.getResult({
                url: "/api/School/FX/DictApi/Save",
                data: self.model,
                finally() { self.sta.loading = false; },
                completed: function () {
                    self.$message.success('设置成功！')
                    self.sta.show = false;
                    self.$emit("on-saved");
                }
            })
        },
        open() {
            this.state = false
        },
        close() {
            if (this.PREVIEW == '' && this.AFTER == '') {
                // this.$message.warning('没有设置提醒时间！')
                this.state = true
                return
            }
            this.whale.confirmText('真的要取消提醒吗？', () => {
                let self = this;
                this.sta.loading = true;
                this.whale.remote.getResult({
                    url: "/api/School/FX/DictApi/Cancel",
                    data: { NAME: "DAY_NOTICE", TYPE: "SAFE" },
                    finally() { self.sta.loading = false; },
                    completed: function (its) {
                        // console.log('Cancel', its.DATA)
                        if (its.DATA) {
                            self.$message.success('取消提醒成功！')
                            self.sta.show = false;
                        }
                    }
                })
            });
        }
    },
}
</script>
<style lang="less" scoped></style>